import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-pam-profile',
  templateUrl: './pam-profile.component.html',
  styleUrls: ['./pam-profile.component.scss']
})
export class PamProfileComponent {
  @Input() form!: FormGroup;
  @Input() userProfile: any;
  @Input() regionsList: any[] = [];
  @Input() countryItems: any[] = [];
  @Input() beGeoItems: any[] = [];
  @Input() selectedTheatre: any;
  @Input() selectedCountry: any;
  @Input() selectedBeGeo: any;
  @Input() pamAgreeFlag = false;
  @Input() progmMgrNm = '';

  @Output() theatreChange = new EventEmitter<any>();
  @Output() countryChange = new EventEmitter<any>();
  @Output() beGeoChange = new EventEmitter<any>();
  @Output() beGeoScrollEnd = new EventEmitter<void>();
  @Output() pamSubmit = new EventEmitter<void>();
  @Output() pamAgreeFlagChange = new EventEmitter<boolean>();
}
